import { render, staticRenderFns } from "./PropertySelector.vue?vue&type=template&id=789421e2&scoped=true"
import script from "./PropertySelector.vue?vue&type=script&lang=js"
export * from "./PropertySelector.vue?vue&type=script&lang=js"
import style0 from "./PropertySelector.vue?vue&type=style&index=0&id=789421e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789421e2",
  null
  
)

export default component.exports